import {
    apiRequest,
    DetailMutasiPegawai,
    UpdateMutasiPegawai,
    ListPegawai,
    ListUnitKerja,
    masterRegion,
    ListJabatan
} from "../../../../../services/adapters/kepegawaian/mutasiPegawaiService"

class UpdateRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", DetailMutasiPegawai, {
            params: query
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", UpdateMutasiPegawai, {
            body: query
        }, true)
    }
    fetchListPegawai = async (query, cancelToken) => {
        return await apiRequest("get", ListPegawai, {
            cancelToken: cancelToken,
            params: query,
        }, true)
    }
    
    fetchRegion = async (query, cancelToken) => {
        return await apiRequest("get", masterRegion, {
            cancelToken: cancelToken,
            params: query
        }, true);
    }
 

    fetchListUnitKerja = async (query, cancelToken) => {
        return await apiRequest("get", ListUnitKerja, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchListJabatan = async (query, cancelToken) => {
        return await apiRequest("get", ListJabatan, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
}

export default UpdateRepository